import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/home/buttons';
import { Card } from '../../components/home/card';

export function InvalidJobRoute() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Card>
            <div className="flex flex-col items-center gap-4 text-center">
                <div className="space-y-2">
                    <h2 className="text-2xl font-semibold text-foreground">{t('route.invalidJob.txtTitle')}</h2>
                    <p className="text-sm text-secondary">{t('route.invalidJob.txtBody')}</p>
                </div>
                <Button variant="secondary" onClick={() => navigate('/')} className="w-full">
                    {t('route.invalidJob.txtAction')}
                </Button>
            </div>
        </Card>
    );
}
